import $ from "jquery";

const Gallery = () => {
	const galleryModal = document.getElementById('galleryModal');

	if (!galleryModal) {
		return;
	}

	const singleImage = (imgUrl) => {
		// Create an image element
		const img = document.createElement('img');
		img.src = imgUrl;

		return img;
	}

	galleryModal.addEventListener('show.bs.modal', event => {
		const {currentTarget} = event;
		const button = event.relatedTarget;
		const form = $(currentTarget).find('form');
		const modalDeleteBtn = galleryModal.querySelector('#removeImage');
		const type = button.getAttribute('data-type');
		const modalBody = galleryModal.querySelector('.modal-body');

		let html = '';
		let formAction = '';
		// Get the modal body

		// Clear the modal body
		modalBody.innerHTML = '';

		if (type === 'ndd-dockets') {
			const imagesContainerId = button.getAttribute('data-images');
			const id = button.getAttribute('data-ndd-id');

			formAction = `/job/tipping/${id}/delete-dockets/`;

			if (!imagesContainerId) {
				return;
			}

			const imagesContainer = document.getElementById(imagesContainerId);

			// Get the images html from the container and insert to modal body
			html = imagesContainer.innerHTML;
			modalBody.innerHTML = html;

		} else {
			const imgId = button.getAttribute('data-img-id');
			formAction = `/job/images/${imgId}/delete/`;

			const img = singleImage(
				button.getAttribute('data-img'),
			);

			// Append the image to the modal body
			modalBody.appendChild(img);
		}

		if (modalDeleteBtn) {
			form.attr('action', formAction);
			modalDeleteBtn.removeAttribute('disabled');
		}

	});

	galleryModal.addEventListener('hide.bs.modal', event => {
		// Get the modal body
		const {currentTarget} = event;
		const modalBody = galleryModal.querySelector('.modal-body');
		const modalDeleteBtn = galleryModal.querySelector('#removeImage');
		const form = $(currentTarget).find('form');

		if (modalDeleteBtn) {
			form.attr('action', '');
			modalDeleteBtn.setAttribute('disabled', 'true');
		}

		// Clear the modal body
		modalBody.innerHTML = '';
	});

}

export default Gallery;
